export default __webpack_public_path__ + "static/media/List-documentation.33b607bc.md";